import { assetIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { AssetPage } from "../assets/asset-page.tsx";
import { loadAsset } from "../assets/loaders.ts";
import { canBrowseAssets } from "../assets/permissions.ts";
import { useViewer } from "../data/hooks.ts";
import { RecordPending } from "../shell/record-pending.tsx";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { assetTabSchema } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/assets/$id/{-$tab}");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id, tab } = route.useParams();
  return viewer === null || !canBrowseAssets(viewer) ? (
    <NoAccessPage />
  ) : (
    <AssetPage viewer={viewer} assetId={id} tab={tab ?? "overview"} />
  );
};

export const Route = createFileRoute("/_app/assets/$id/{-$tab}")({
  params: {
    parse: ({ id, tab }) => ({
      id: parameterOrNotFound(assetIdSchema, id),
      tab: parameterOrNotFound(assetTabSchema.exclude(["overview"]).optional(), tab),
    }),
    stringify: ({ id, tab }) => ({ id, tab }),
  },
  loader: async ({ context, params }) => loadAsset(context.data, params.id),
  pendingComponent: () => <RecordPending lead="square" hasTabs />,
  component: Page,
});
